<!-- If the client has set the option to login with azure in its environment -->
<app-login-azure *ngIf="loginWithAzure"></app-login-azure>
<!-- Otherwise the app will use the default login -->
<loginComponent *ngIf="!loginWithAzure"></loginComponent>
